import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { renderChildren } from '../../BlockRenderer/renderChildren.js';
import { useMobileMode } from '../../hooks/useMobileMode.js';
import { BlockWrapper } from '../../ui-kit/BlockWrapper.js';
import { DefaultFoldButton } from '../../ui-kit/Foldable/DefaultFoldButton.js';
import { Foldable } from '../../ui-kit/Foldable/Foldable.js';
import { FoldableSection } from '../../ui-kit/Foldable/FoldableSection.js';
import { UniBlock } from '../../UniBlock/UniBlock.js';
import { style } from '../../utils/style.js';
import { AccordionFoldButton } from './AccordionFoldButton.js';
import { getFoldableStyles } from './getFoldableStyles.js';
import { getIconName } from './getIconName.js';
export const RollupItem = UniBlock(({ className = '', isExpanded, isFoldButtonOnTop = true, label = 'Развернуть', labelIcon, labelIconBgVersion, foldButtonVersion = 'default', 
// eslint-disable-next-line @typescript-eslint/no-unused-vars
version, role, ...rest }) => {
    const isMobile = useMobileMode();
    return (_jsx(BlockWrapper, { className: style('w-full border-0 border-b border-solid border-main-divider last:border-b-0', className), defaultPadding: "p-0", tag: "div", version: "transparent", role: role, ...rest, children: _jsx(Foldable, { isFoldButtonOnTop: isFoldButtonOnTop, unfoldedByDefault: isExpanded, renderFoldableSection: ({ isUnfolded }) => (_jsx(FoldableSection, { className: style('gap-lg', getFoldableStyles(isMobile)), isUnfolded: isUnfolded, children: renderChildren({
                    ...rest,
                    extraProps: { className: 'w-full', padding: 'p-0' },
                }) })), renderFoldButton: ({ isUnfolded, onToggle }) => renderFoldButton({
                foldButtonVersion,
                label,
                labelIcon,
                labelIconBgVersion,
                isUnfolded,
                onToggle,
                isMobile,
            }) }) }));
}, {
    childrenTypes: { exclude: ['RollupItem'] },
});
const renderFoldButton = ({ foldButtonVersion, label: defaultLabel, labelIcon, labelIconBgVersion, isUnfolded, onToggle, isMobile = false, }) => {
    const label = defaultLabel || (isUnfolded ? 'Скрыть' : 'Развернуть');
    const icon = getIconName(isUnfolded, isMobile);
    return foldButtonVersion === 'accordion' ? (_jsx(AccordionFoldButton, { label: label, labelIcon: labelIcon, labelIconBgVersion: labelIconBgVersion, icon: icon, onToggle: onToggle })) : (_jsx(DefaultFoldButton, { label: label, icon: isUnfolded ? 'ArrowUpIcon' : 'ArrowDownIcon', onClick: onToggle }));
};
//# sourceMappingURL=RollupItem.js.map